import React, { useCallback } from 'react';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import { getDeviationResourceType } from '../../_helpers';
import PopperDropdownManager from '../../../Dropdown/PopperDropdownLayout/PopperDropdownManager';
import PopperDropdownToggle from '../../../Dropdown/PopperDropdownLayout/PopperDropdownToggle';
import StandardDropdownMenu from '../../../Dropdown/Preset/StandardDropdown/StandardDropdownMenu';
import { useDropdownItems } from '../../../Dropdown/hooks/useDropdownItems';
import s from './ThumbActions.scss';
var ThumbActions = function (_a) {
    var deviation = _a.deviation, actions = _a.actions, className = _a.className, children = _a.children;
    var dropdownId = useUniqueId();
    var logger = useBiLogger();
    var filteredItems = useDropdownItems(actions).filteredItems;
    var typeid = getDeviationResourceType(deviation);
    var onOpen = useCallback(function () {
        if (!(deviation === null || deviation === void 0 ? void 0 : deviation.deviationId)) {
            return;
        }
        logger(BiData({
            evid: 417,
            typeid: typeid,
            itemid: deviation.deviationId,
            sectionname: BiContextProvidedValue,
            sort_type: BiContextProvidedValue,
            reason_shown: BiContextProvidedValue,
            rank: BiContextProvidedValue,
            feed_mode: BiContextProvidedValue,
            sectionid: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            is_grouped: BiContextProvidedValue,
        }));
    }, [logger, typeid, deviation === null || deviation === void 0 ? void 0 : deviation.deviationId]);
    if (!filteredItems.length) {
        return null;
    }
    return (React.createElement(PopperDropdownManager, { onOpen: onOpen },
        React.createElement(PopperDropdownToggle, { className: className, "aria-owns": dropdownId }, children),
        React.createElement(StandardDropdownMenu, { id: dropdownId, items: filteredItems, role: "menu", className: s['menu'] })));
};
ThumbActions.displayName = 'ThumbActions';
export default ThumbActions;
//# sourceMappingURL=ThumbActions.js.map